<template>
  <div :class="wrapperClass">
    <a @click.prevent="$emit('close')" class="close-button no-underline" :class="buttonClass" href="#">
<!--      <span :class="textClass">Hide message</span>-->
      <div :class="'w-[' + iconSize + 'px] h-[' + iconSize + 'px] flex items-center justify-center'">
        <svg :width="iconSize" :height="iconSize" :viewBox="'0 0 42 43'" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="1" y="1.125" width="40" height="40" rx="20" stroke="#3B3C4A" stroke-width="2"/>
          <g clip-path="url(#clip0_3890_221519)">
            <path d="M16.7518 15.125L21.3672 19.7404L25.9826 15.125C26.3576 14.75 26.9922 14.75 27.3672 15.125C27.771 15.5288 27.7422 16.1346 27.3672 16.5096L22.7518 21.125L27.3672 25.7404C27.771 26.1442 27.7422 26.75 27.3672 27.125C26.9633 27.5288 26.3864 27.5288 25.9826 27.125L21.3672 22.5096L16.7518 27.125C16.348 27.5288 15.771 27.5288 15.3672 27.125C14.9922 26.75 14.9633 26.1442 15.3672 25.7404L19.9826 21.125L15.3672 16.5096C14.9922 16.1346 14.9633 15.5288 15.3672 15.125C15.7422 14.75 16.3768 14.75 16.7518 15.125Z" fill="#3B3C4A"/>
          </g>
          <defs>
            <clipPath id="clip0_3890_221519">
              <rect width="25.265" height="24.578" fill="white" transform="translate(8.36719 8.83606)"/>
            </clipPath>
          </defs>
        </svg>
      </div>
    </a>
  </div>
</template>
<script>
export default {
  props: {
    size: { type: String, default: 'large' }
  },
  computed: {
    wrapperClass() {
      return this.size === 'small' ? '' : 'flex-shrink-0 ml-4'
    },
    buttonClass() {
      return this.size === 'small' ? 'flex items-center gap-2 text-black' : 'flex items-center gap-2 mr-4 text-dark'
    },
    textClass() {
      return this.size === 'small' ? 'text-sm font-light' : 'text-sm lg:text-lg font-light'
    },
    iconSize() {
      return this.size === 'small' ? '32' : '42'
    }
  },
}
</script>